import { combineReducers } from 'redux';

import match from './match';
import dailyMatches from './dailyMatches';
import vidiprinter from './vidiprinter';
import playerProfile from './playerProfile';
import teamDetails from './teamDetails';
import teamSquad from './teamSquad';
import teamList from './teamList';
import teamForm from './teamForm';
import teamHeadToHead from './teamHeadToHead';
import leagueTable from './leagueTable';
import competition from './competition';
import competitions from './competitions';
import competitionMatches from './competitionMatches';
import team from './team';

export default combineReducers({
  match,
  dailyMatches,
  vidiprinter,
  playerProfile,
  teamDetails,
  teamSquad,
  teamList,
  teamForm,
  teamHeadToHead,
  leagueTable,
  competition,
  competitions,
  competitionMatches,
  team
});



// WEBPACK FOOTER //
// ./modules/Football/reducers/reducer.js